angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "REQUEST_REFERENCE_MODAL": {
    "REQUIRED" : "This field is required",
    "MESSAGE_MIN_LENGTH" : "Your message is too short. Please be more specific.",
    "SUCCESS": {
      "HEADER": "Thank You!",
      "BODY": "Your reference has been submitted and will appear shortly on the local’s profile.",
      "LABEL": "OK, got It",
    },
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/request_reference/request_reference_modal/request_reference_modal.json
// module id = 434
// module chunks = 24